import {Avatar} from 'antd'
import {articleGroups_CategoriesSchema} from 'apis'
import {articleSchema} from 'apis/schema'
import {SelectEntityItem} from 'components/SelectEntityItem'
import getLinkToDetail from 'helpers/getLinkToDetail'
import getTitle from 'helpers/getTitle'
import _ from 'lodash'
import Translate from 'modules/local/Translate'
import React from 'react'
import {BsPersonFill} from 'react-icons/bs'
import {Link} from 'react-router-dom'
import {renderIf} from 'views/Shared'
import {paths} from "../../MainPage/contains";
import EmptyHolder from "../../../components/EmptyHolder";
import {GiIronCross} from "react-icons/gi";
import {HeaderWithIconLine} from "../../AppLocals/Templates/items/ListHeader";
import getAvatar from "../../../helpers/getAvatar";
import useTranslate from "../../../modules/local/useTranslate";
import ImageLoader from "../../../components/ImageLoader";
import {Photo} from "../../../conts/imageBase64";
import {renderIfElse} from "../../Shared";
import categoryIcons from "../../../conts/categoryIcons";
import {PiShootingStarFill} from "react-icons/pi";
import {formatSimplifyDate} from "../../../helpers/dateUtils";


const MetaInformation = ({item}) => {
    const t = useTranslate()
    const {creator, container, created} = item ?? {}

    return (
        <div className="flex items-center gap-2">
            <Avatar
                size={30}
                icon={<BsPersonFill size={14} className="text-color-500"/>}
                src={getAvatar(creator)}
                className="flex flex-center background-200"
            />
            <div className="flex flex-col flex-1">
                <div className="flex items-baseline gap-1 leading-tight">
                    <Link to={getLinkToDetail(creator)}
                          className="font-bold text-sm text-primary-900 no-underline cursor-pointer max-lines-1">
                        {getTitle(creator)}
                    </Link>
                    <span className="whitespace-no-wrap text-2xs text-color-500 italic">
                        {t('posted on channel')}
                    </span>
                </div>
                <div className="flex items-baseline gap-1 text-sm italic leading-tight">
                    <Link to={getLinkToDetail(container)}
                          className="font-medium text-xs text-color-100 no-underline max-lines-1 cursor-pointer">
                        {getTitle(container)}
                    </Link>
                    {' - '}
                    <span className="text-2xs text-color-400 whitespace-no-wra tracking-wide">
                        {formatSimplifyDate(created, 'fullTime')}
                    </span>
                </div>
            </div>
        </div>
    )
}

const ContentMeta = ({item}) => {
    const {description, cover_photo} = item ?? {}

    return (
        <div className="ml-1 flex flex-col gap-1">
            <Link to={getLinkToDetail(item)} className="font-bold text-color-000 no-underline leading-snug">
                {getTitle(item)}
            </Link>
            <div className="w-full flex gap-2 lg:gap-3">
                {!_.isEmpty(description) && (
                    <div style={{lineHeight: 1.8}} className="flex-1 max-lines-3 text-base text-color-300">
                        {description}
                    </div>
                )}
                {renderIf(
                    cover_photo,
                    <ImageLoader
                        fallback={Photo}
                        src={cover_photo}
                        className="w-20 md:w-28 h-20 object-cover rounded-md"
                        style={{objectPosition: "center"}}
                    />
                )}
            </div>
        </div>
    )
}

const renderArticleGroup = (item, index) => {
    return (
        <Translate key={index}>
            {(t) => (
                <SelectEntityItem item={item} schema={articleGroups_CategoriesSchema}>
                    {(item) => {
                        const Icon = _.get(categoryIcons, item.idname, categoryIcons['default'])
                        return renderIf(
                            item,
                            <div className="flex flex-col gap-2">
                                <HeaderWithIconLine
                                    lineColor="border-primary-100"
                                    renderTitle={() => (
                                        <div className="flex items-center gap-2">
                                            <Icon size={20}/>
                                            <span className="font-bold text-lg text-primary-600 uppercase tracking-wider">
                                                {t(getTitle(item))}
                                            </span>
                                        </div>
                                    )}
                                />
                                <div className="flex flex-col gap-3">
                                    {Array.from(_.get(item, 'articles', [])).map((sub, index) => {
                                        const {description, cover_photo} = sub ?? {}
                                        return (
                                            <div key={index} className="p-3 flex flex-col gap-2 background shadow hover:shadow-md rounded-xl relative">
                                                <MetaInformation item={sub}/>
                                                <ContentMeta item={sub} />
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        )
                    }}
                </SelectEntityItem>
            )}
        </Translate>
    )
}

const ArticleResult = ({
    latest_articles = [],
    categories: article_groups = [],
}) => {
    const t = useTranslate()
    return (
        <div className="w-full flex flex-col gap-6">
            {renderIfElse(
                latest_articles.length > 0,
                <div className="flex flex-col gap-2">
                    <HeaderWithIconLine
                        line={false}
                        renderTitle={() => (
                            <div className="flex items-center gap-2">
                                <PiShootingStarFill size={14} className="text-blue-500"/>
                                <span className="font-medium text-blue-600 italic tracking-wider">
                                    {t('lasted-articles')}
                                </span>
                            </div>
                        )}
                    />
                    <div className="flex flex-col gap-3">
                        {Array.from(latest_articles).map((transformed_id, index) => (
                            <SelectEntityItem key={index} item={transformed_id} schema={articleSchema}>
                                {(item) => {
                                    return renderIf(
                                        item,
                                        <div className="p-3 flex flex-col gap-2 background shadow hover:shadow-md hover:scale-3xs rounded-xl relative">
                                            <MetaInformation item={item}/>
                                            <div className="flex flex-col gap-1">
                                                <ContentMeta item={item} />
                                                {renderIf(
                                                    _.get(item, 'categories.length') > 0,
                                                    <div className="flex flex-wrap gap-3">
                                                        {_.get(item, 'categories', []).map((e, index) => (
                                                            <div key={index} className="flex items-center gap-1 text-blue-500">
                                                                <GiIronCross size={7}/>
                                                                <Link
                                                                    to={
                                                                        paths.categoryPath.replace(':category', e.id)

                                                                    }
                                                                    className="font-medium text-xs italic no-underline">
                                                                    {e.name}
                                                                </Link>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    )
                                }}
                            </SelectEntityItem>
                        ))}
                    </div>
                </div>,
                <EmptyHolder />
            )}
            {Array.from(article_groups).map(renderArticleGroup)}
        </div>
    )
}

export default ArticleResult
